// covered-by: frontends/carrie/src/ask-v2/rail/__tests__/AskV2RightRail.test.tsx
import { CaretDown } from "@phosphor-icons/react";
import { type ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";

type AskV2RailSubsectionProps = {
  id: string;
  title: string;
  defaultOpen?: boolean;
  children: ReactNode;
};

export function AskV2RailSubsection({
  id,
  title,
  defaultOpen = true,
  children,
}: AskV2RailSubsectionProps) {
  const { t } = useTranslation("ui");
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div data-testid={`ask-v2-rail-subsection-${id}`}>
      <button
        type="button"
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
        aria-label={t("askV2.rail.toggleSubsection", { section: title })}
        data-testid={`ask-v2-rail-subtoggle-${id}`}
        className="flex w-full items-center gap-2 rounded-md bg-base-white py-1 text-left"
      >
        <h3 className="flex-1 text-[13px] font-bold text-puntt-neutral-gray-12">
          {title}
        </h3>
        <CaretDown
          size={14}
          aria-hidden="true"
          className={`shrink-0 text-puntt-neutral-gray-11 transition-transform ${open ? "" : "-rotate-90"}`}
        />
      </button>
      {open ? <div className="mt-2">{children}</div> : null}
    </div>
  );
}
